import { Package, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";

const LowStockAlerts = ({ items, onGeneratePO }) => {
  return (
    <div className="bg-white border border-slate-200 rounded-sm">
      <div className="p-6 border-b border-slate-200">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold text-slate-900 uppercase tracking-wider" style={{ fontFamily: 'Chivo, sans-serif' }}>
            Low Stock Alerts
          </h2>
          {items.length > 0 && (
            <Button
              onClick={() => onGeneratePO(items, 'lowstock')}
              className="bg-orange-600 hover:bg-orange-700 text-white"
              data-testid="generate-po-lowstock-btn"
            >
              <FileText size={16} className="mr-2" />
              Generate PO
            </Button>
          )}
        </div>
      </div>
      <div className="overflow-x-auto">
        {items.length === 0 ? (
          <div className="p-8 text-center">
            <Package className="mx-auto text-slate-300 mb-3" size={48} />
            <p className="text-slate-500">No low stock items</p>
          </div>
        ) : (
          <table className="w-full data-table" data-testid="low-stock-table">
            <thead className="bg-slate-100">
              <tr>
                <th className="text-left px-6 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">Part Number</th>
                <th className="text-left px-6 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">Name</th>
                <th className="text-right px-6 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">Current Stock</th>
                <th className="text-right px-6 py-3 text-xs font-bold text-slate-600 uppercase tracking-wider">Reorder Level</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((item) => (
                <tr key={item.id} className="hover:bg-orange-50/50 transition-colors" data-testid={`low-stock-item-${item.part_number}`}>
                  <td className="px-6 py-4 text-sm font-medium text-slate-900">{item.part_number}</td>
                  <td className="px-6 py-4 text-sm text-slate-700">{item.name}</td>
                  <td className="px-6 py-4 text-sm text-right font-semibold">
                    <span className={item.quantity === 0 ? "text-red-600" : "text-orange-500"}>{item.quantity}</span>
                  </td>
                  <td className="px-6 py-4 text-sm text-right text-slate-600">{item.reorder_level}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export { LowStockAlerts };
